import React from "react"
import "./StoryblokLink.scss"

function NormalizeURL (url) {
  let newUrl = url
  if(!newUrl.startsWith('/')) {
    newUrl = `/${newUrl}`
  }
  if(newUrl.endsWith('/')) {
    newUrl = newUrl.substring(0,newUrl.length-1)
  }
  return newUrl
}

const StoryblokLink = ({ SBLinkData, text, withClass, children, newWindow }) => {
  if(!SBLinkData) {
    if(children) {
      return <span className={withClass}>{children}</span>
    }
    return <span className={withClass}>{text}</span>
  }

  if(SBLinkData.linktype === "asset") {
    if(children) {
      return <a className={withClass} href={SBLinkData.cached_url} target={newWindow ? "_blank" : "_self"}>{children}</a>
    }
    else {
      return <a className={withClass} href={SBLinkData.cached_url} target={newWindow ? "_blank" : "_self"}>{text}</a>
    }
  }
  if(SBLinkData.linktype === "url" && SBLinkData.url) {
    if(children) {
      return <a className={withClass} href={SBLinkData.url} target={newWindow ? "_blank" : "_self"}>{children}</a>
    }
    else {
      return <a className={withClass} href={SBLinkData.url} target={newWindow ? "_blank" : "_self"}>{text}</a>
    }
  }
  if(SBLinkData.linktype === "story") {
    if(children) {
      if (!SBLinkData.cached_url && SBLinkData.id ) {
        return <a className={withClass} href={"/"} target={newWindow ? "_blank" : "_self"}>{children}</a>
      }
      return <a className={withClass} href={NormalizeURL(SBLinkData.cached_url)} target={newWindow ? "_blank" : "_self"}>{children}</a>
    }
    else {
      if (!SBLinkData.cached_url && SBLinkData.id ) {
        return <a className={withClass} href={"/"} target={newWindow ? "_blank" : "_self"}>{text}</a>
      }
      return <a className={withClass} href={NormalizeURL(SBLinkData.cached_url)} target={newWindow ? "_blank" : "_self"}>{text}</a>
    }
   
  }

  if(children) {
    return <span className={withClass}>{children}</span>
  }
  return <span className={withClass}>{text}</span>
}

export default StoryblokLink